import styled from 'styled-components/macro'

import { Dropdown } from '@loadsmart/loadsmart-ui'
import { Layout } from '@loadsmart/miranda-react'
import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { Icon } from 'core/ui/components/icon/Icon'

import { AgnosticShipmentSort } from '../domain/AgnosticShipmentSort'
import { formatSort } from '../presenters/agnosticShipmentSortPresenter'

const StyledDropdownTrigger = styled(Dropdown.Trigger)`
  button {
    text-transform: none;
  }
`

const StyledDropdownItem = styled(Dropdown.Item)`
  background-color: ${({ 'aria-selected': ariaSelected }) =>
    toCSSValue(ariaSelected ? 'color-background-highlight' : 'color-background-primary')};
`

export type ShipperLoadsSortProps = {
  value?: AgnosticShipmentSort
  onChange: (sort: AgnosticShipmentSort) => void
}

export function ShipperLoadsSort({ value, onChange }: ShipperLoadsSortProps) {
  return (
    <Dropdown>
      <StyledDropdownTrigger>
        <Layout.Group gap="spacing-1">
          <Icon name="arrows-up-down" />
          <span>Sort</span>
        </Layout.Group>
      </StyledDropdownTrigger>
      <Dropdown.Menu>
        {[
          AgnosticShipmentSort.Status,
          AgnosticShipmentSort.PickupAsc,
          AgnosticShipmentSort.PickupDesc,
        ].map(item => (
          <StyledDropdownItem
            key={item}
            aria-selected={value === item}
            trailing={value === item ? <Icon name="check" /> : undefined}
            onClick={() => onChange(item)}
          >
            {formatSort(item)}
          </StyledDropdownItem>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
